<div class="d-flex align-items-center flex-column">
  @if (!showBandO()) {
    <rs-web-whitelabel-image
      [whitelabelImage]="whiteLabelImage.ORDER_PLACED"
    ></rs-web-whitelabel-image>
    <h1 class="primary-text">{{ 'ticket.b_and_o_title_l' | translate }}</h1>
    <p class="primary-text">{{ 'ticket.b_and_o_short_description_l' | translate }}</p>
    <button im-button class="primary" (click)="showBandOTicketing()">
      {{ 'ticket.b_and_o_button' | translate }}
    </button>
  } @else {
    <rs-web-ticket-b-and-o-creation-page class="w-100"></rs-web-ticket-b-and-o-creation-page>
  }
</div>
